/* eslint-disable prettier/prettier */
import { Checkbox, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { UPLOADDOCUMENT } from "../../../../../containers/smartForms/components/constants";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import Table from "../../../../generic-table";
import GenericModal from "../../../../modal-closebtn/index";


function ModelerModalDocumentsForSignature({
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  selectBox,
  saveDocuments,
  fields,
  docsToSign,
}) {
  const [state, setState] = useState({ open: true, fullWidth: true, maxWidth: "xl" });
  const [selectedDocs, setSelectedDocs] = useState({});

  let documentoVariables = getDocumentoVariables(fields);
  documentoVariables = documentoVariables.concat(getUniqueDocumentServiceFields(businessObject),);

  documentoVariables = documentoVariables.filter((value, index, self) => {
    return index === self.findIndex((obj) => obj.id === value.id);
  });

  useEffect(() => {
    if (!docsToSign || docsToSign.length <= 0) return;

    const auxSelectedDocs = {};
    for (let i = 0; i < docsToSign.length; i++) {
      auxSelectedDocs[docsToSign[i].id] = {
        id: docsToSign[i].id,
        name: docsToSign[i].name,
        isSignatureRequired: !!docsToSign[i].isSignatureRequired,
      };
    }

    setSelectedDocs(auxSelectedDocs);
  }, [docsToSign]);

  // close
  const handleClose = () => {

    const documentsSelected = Object.keys(selectedDocs)
      .map((key) => {
        return {
          id: selectedDocs[key].id,
          name: selectedDocs[key].name,
          type: UPLOADDOCUMENT,
          isSignatureRequired: !!selectedDocs[key].isSignatureRequired,
        };
    });

    saveDocuments(
      businessObject,
      element,
      extensionElements,
      bpmnFactory,
      selectBox,
      documentsSelected,
    );

    setState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  // on change document
  const handleSelectDocument = (data) => {
    const selectedIds = Array.from(data?.ids || []);
    let auxSelectedDocs = {};

    for(let i = 0; i < selectedIds.length; i++){

      const idSelected = selectedIds[i];

      const doc = documentoVariables.find((d) => d.id === idSelected);
      if(!doc) return;

      const currentDoc = selectedDocs[idSelected];

      auxSelectedDocs[idSelected] = {
        id: doc.id,
        name: doc.name,
        isSignatureRequired: !!currentDoc?.isSignatureRequired,
      }
    }

    setSelectedDocs(auxSelectedDocs);
  };

  // on change required
  const handleSelectIsRequired = (event, rowData) => {
    const { checked } = event.target;
    let currentDoc = selectedDocs[rowData.id];

    if (currentDoc) {
      currentDoc.isSignatureRequired = checked;
    } else {
      currentDoc = {
        id: rowData.id,
        name: rowData.name,
        isSignatureRequired: checked,
      };
    }

    if (checked) {
      rowData.tableData = { id: rowData.id, checked: true };
    }

    setSelectedDocs((prev) => ({
      ...prev,
      [rowData.id]: { ...currentDoc },
    }));
  };

  // adicionando o atributo checked nos documentos selecionados
  const rowSelectionModel = {
    type: 'include',
    ids: new Set(Object.keys(selectedDocs))
  };

  const dataTable = {
    title: language.documents,
    headers: [
      { title: language.id, field: "id" },
      { 
        title: language.required, 
        field: "isSignatureRequired",
        render: (rowData) => {
          const checked = selectedDocs[rowData?.id]?.isSignatureRequired;
          return <Checkbox 
            onChange={(event) => {
              handleSelectIsRequired(event, rowData);
            }}
            value={checked}
            checked={checked || false}
          />
        },
      },
   ],

   actions: [],
   data: documentoVariables,
  };

  const { open } = state;

  return (
    open && (
      <Provider>
        <GenericModal
          title={language.documentsInThisProcess}
          handleClose={handleClose}
          size={state.maxWidth}
          bigHeight
          open={true}
        >
          <Paper>
            <Table
              tableData={dataTable}
              onRowSelectionModelChange={handleSelectDocument}
              rowSelectionModel={rowSelectionModel}
              checkboxSelection
            />
          </Paper>
        </GenericModal>
      </Provider>
    )
  );
}

export default ModelerModalDocumentsForSignature;
